// Shared Framer Motion variants — restrained, purposeful institutional motion.

const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1, ease: EASE } },
};

export const stagger = (delayChildren = 0, staggerChildren = 0.1) => ({
  hidden: {},
  show: {
    transition: { delayChildren, staggerChildren },
  },
});

export const lineMask = {
  hidden: { y: "115%" },
  show: {
    y: 0,
    transition: { duration: 1.05, ease: EASE },
  },
};

export const EASE_CURVE = EASE;
